import { DistributionFiltersApi, LazyParamsFilters } from '@/app/models/distribution'
import { FilterMatchMode } from 'primereact/api'

export const getDistributionFiltersBody = (
    filters: Record<any, LazyParamsFilters>
): DistributionFiltersApi => {
    return {
        storeId: filters.store_id?.value || null,
        storeName: filters.store_name?.value || null,
        bannerList: !(filters.banner_desc?.value || [])[0]?.code
            ? filters.banner_desc?.value
            : filters.banner_desc?.value?.map(
                  (bannerObj: { code: string; label: string }) => bannerObj.code
              ) || null,
        storeIdList: filters.storeIdList?.value,
        macroregionList: filters.macroregion?.value,
        regionList: filters.region?.value,
        countryList: filters.country?.value,
        zoneList: filters.zone_desc?.value,
        storeLocationList: filters.store_location?.value,
        cityList: filters.city?.value,
        segmentList: filters.segment?.value,
        hostList: filters.host?.value,
        storeHostList: filters.store_host_name?.value,
        businessModelList: filters.business_model?.value,
    }
}

export const getInitialFilters = (
    filtersOptionsMap: Record<string, any>,
    filters?: Record<any, LazyParamsFilters>,
    field?: string
) => {
    return {
        store_name: {
            value: filters?.store_name?.value,
            matchMode: FilterMatchMode.CONTAINS,
        },
        banner_desc: {
            value:
                !!field && field !== 'banner_desc'
                    ? filters?.banner_desc?.value?.filter((value) =>
                          filtersOptionsMap.bannerObject.some((option) => option === value)
                      )
                    : filters?.banner_desc?.value || undefined,
            matchMode: FilterMatchMode.IN,
            options:
                !!field && field === 'banner_desc'
                    ? filters?.banner_desc?.options || []
                    : filtersOptionsMap.bannerObject,
            additionalProps: {
                appendTo: 'self',
            },
        },
        store_id: {
            value: filters?.store_id?.value,
            matchMode: FilterMatchMode.CONTAINS,
        },
        country: {
            value:
                !!field && field !== 'country'
                    ? filters?.country?.value?.filter((value) =>
                          filtersOptionsMap.country.some((option) => option === value)
                      )
                    : filters?.country.value || undefined,
            matchMode: FilterMatchMode.IN,
            options:
                !!field && field === 'country'
                    ? filters?.country?.options || []
                    : filtersOptionsMap.country,
            additionalProps: { appendTo: 'self' },
        },
        macroregion: {
            value:
                !!field && field !== 'macroregion'
                    ? filters?.macroregion?.value?.filter((value) =>
                          filtersOptionsMap.macroregion.some((option) => option === value)
                      )
                    : filters?.macroregion.value || undefined,
            matchMode: FilterMatchMode.IN,
            options:
                !!field && field === 'macroregion'
                    ? filters?.macroregion?.options || []
                    : filtersOptionsMap.macroregion,
            additionalProps: { appendTo: 'self' },
        },
        region: {
            value:
                !!field && field !== 'region'
                    ? filters?.region?.value?.filter((value) =>
                          filtersOptionsMap.region.some((option) => option === value)
                      )
                    : filters?.region.value || undefined,
            matchMode: FilterMatchMode.IN,
            options:
                !!field && field === 'region'
                    ? filters?.region?.options || []
                    : filtersOptionsMap.region,
            additionalProps: { appendTo: 'self' },
        },
        zone_desc: {
            value:
                !!field && field !== 'zone_desc'
                    ? filters?.zone_desc?.value?.filter((value) =>
                          filtersOptionsMap.zoneDesc.some((option) => option === value)
                      )
                    : filters?.zone_desc.value || undefined,
            matchMode: FilterMatchMode.IN,
            options:
                !!field && field === 'zone_desc'
                    ? filters?.zone_desc?.options || []
                    : filtersOptionsMap.zoneDesc,
            additionalProps: { appendTo: 'self' },
        },
        host: {
            value:
                !!field && field !== 'host'
                    ? filters?.host?.value?.filter((value) =>
                          filtersOptionsMap.host.some((option) => option === value)
                      )
                    : filters?.host.value || undefined,
            matchMode: FilterMatchMode.IN,
            options:
                !!field && field === 'host' ? filters?.host?.options || [] : filtersOptionsMap.host,
            additionalProps: { appendTo: 'self' },
        },
        city: {
            value:
                !!field && field !== 'city'
                    ? filters?.city?.value?.filter((value) =>
                          filtersOptionsMap.city.some((option) => option === value)
                      )
                    : filters?.city.value || undefined,
            matchMode: FilterMatchMode.IN,
            options:
                !!field && field === 'city' ? filters?.city?.options || [] : filtersOptionsMap.city,
            additionalProps: { appendTo: 'self' },
        },
        store_location: {
            value:
                !!field && field !== 'store_location'
                    ? filters?.store_location?.value?.filter((value) =>
                          filtersOptionsMap.storeLocation.some((option) => option === value)
                      )
                    : filters?.store_location.value || undefined,
            matchMode: FilterMatchMode.IN,
            options:
                !!field && field === 'store_location'
                    ? filters?.store_location?.options || []
                    : filtersOptionsMap.storeLocation,
            additionalProps: { appendTo: 'self' },
        },
        store_host_name: {
            value:
                !!field && field !== 'store_host_name'
                    ? filters?.store_host_name?.value?.filter((value) =>
                          filtersOptionsMap.storeHostName.some((option) => option === value)
                      )
                    : filters?.store_host_name.value || undefined,
            matchMode: FilterMatchMode.IN,
            options:
                !!field && field === 'store_host_name'
                    ? filters?.store_host_name?.options || []
                    : filtersOptionsMap.storeHostName,
            additionalProps: { appendTo: 'self' },
        },
        business_model: {
            value:
                !!field && field !== 'business_model'
                    ? filters?.business_model?.value?.filter((value) =>
                          filtersOptionsMap.businessModel.some((option) => option === value)
                      )
                    : filters?.business_model.value || undefined,
            matchMode: FilterMatchMode.IN,
            options:
                !!field && field === 'business_model'
                    ? filters?.business_model?.options || []
                    : filtersOptionsMap.businessModel,
            additionalProps: { appendTo: 'self' },
        },
        segment: {
            value:
                !!field && field !== 'segment'
                    ? filters?.segment?.value?.filter((value) =>
                          filtersOptionsMap.segment.some((option) => option === value)
                      )
                    : filters?.segment.value || undefined,
            matchMode: FilterMatchMode.IN,
            options:
                !!field && field === 'segment'
                    ? filters?.segment?.options || []
                    : filtersOptionsMap.segment,
            additionalProps: { appendTo: 'self' },
        },
    }
}

export const setSmartFiltersOptions = (filters: Record<any, LazyParamsFilters>) => {
    return {
        ...filters,
        banner_desc: {
            ...filters.banner_desc,
            options: filters.banner_desc.options.map((o) => ({
                label: o.label,
                value: o.code,
            })),
            value: [...(filters.banner_desc.value?.map((o) => o.code) || [])],
        },
        country: {
            ...filters.country,
            options: filters.country.options.map((o) => ({
                label: o,
                value: o,
            })),
            value: [...(filters.country.value || [])],
        },
        macroregion: {
            ...filters.macroregion,
            options: filters.macroregion.options.map((o) => ({
                label: o,
                value: o,
            })),
            value: [...(filters.macroregion.value || [])],
        },
        region: {
            ...filters.region,
            options: filters.region.options.map((o) => ({
                label: o,
                value: o,
            })),
            value: [...(filters.region.value || [])],
        },
        zone_desc: {
            ...filters.zone_desc,
            options: filters.zone_desc.options.map((o) => ({
                label: o,
                value: o,
            })),
            value: [...(filters.zone_desc.value || [])],
        },
        host: {
            ...filters.host,
            options: filters.host.options.map((o) => ({
                label: o,
                value: o,
            })),
            value: [...(filters.host.value || [])],
        },
        city: {
            ...filters.city,
            options: filters.city.options.map((o) => ({
                label: o,
                value: o,
            })),
            value: [...(filters.city.value || [])],
        },
        store_location: {
            ...filters.store_location,
            options: filters.store_location.options.map((o) => ({
                label: o,
                value: o,
            })),
            value: [...(filters.store_location.value || [])],
        },
        store_host_name: {
            ...filters.store_host_name,
            options: filters.store_host_name.options.map((o) => ({
                label: o,
                value: o,
            })),
            value: [...(filters.store_host_name.value || [])],
        },
        business_model: {
            ...filters.business_model,
            options: filters.business_model.options.map((o) => ({
                label: o,
                value: o,
            })),
            value: [...(filters.business_model.value || [])],
        },
        segment: {
            ...filters.segment,
            options: filters.segment.options.map((o) => ({
                label: o,
                value: o,
            })),
            value: [...(filters.segment.value || [])],
        },
    }
}

export const getSmartFiltersValue = (
    smartFilter: Record<string, string[]>
): Record<any, LazyParamsFilters> => {
    return {
        banner_desc: {
            value: Array.isArray(smartFilter?.bannerDesc)
                ? smartFilter.bannerDesc
                : smartFilter?.bannerDesc
                ? [smartFilter.bannerDesc]
                : [],
        },
        country: { value: smartFilter?.country },
        macroregion: {
            value: smartFilter?.macroregion,
        },
        region: { value: smartFilter?.region },
        zone_desc: {
            value: smartFilter?.zoneDesc,
        },
        host: { value: smartFilter?.host },
        city: { value: smartFilter?.city },
        store_location: {
            value: smartFilter?.storeLocation,
        },
        store_host_name: {
            value: smartFilter?.storeHostName,
        },
        business_model: {
            value: smartFilter?.businessModel,
        },
        segment: { value: smartFilter?.segment },
    }
}

export const setSmartFiltersValue = (
    smartFilter: Record<string, any[]>,
    columnFilter?: Record<any, LazyParamsFilters>,
    field?: string
): Record<any, LazyParamsFilters> => {
    const bannerDesc = Array.isArray(smartFilter?.bannerDesc)
        ? smartFilter.bannerDesc
        : smartFilter?.bannerDesc
        ? [smartFilter.bannerDesc]
        : []
    return {
        ...columnFilter,
        banner_desc: {
            ...columnFilter.banner_desc,
            value: bannerDesc[0]?.code ? bannerDesc?.map((o) => o.code) : bannerDesc,
            options: !!(columnFilter.banner_desc.options || [])[0]?.code
                ? columnFilter.banner_desc.options.map((o) => ({
                      label: o.label,
                      value: o.code,
                  }))
                : columnFilter.banner_desc.options,
        },
        country: {
            ...columnFilter.country,
            options:
                columnFilter.country.options && columnFilter.country.options[0]?.label
                    ? columnFilter.country.options
                    : (columnFilter.country.options || []).map((o) => ({
                          label: o,
                          value: o,
                      })),
            value:
                !!field && field !== 'country' ? columnFilter.country.value : smartFilter?.country,
        },
        macroregion: {
            ...columnFilter.macroregion,
            options:
                columnFilter.macroregion.options && columnFilter.macroregion.options[0]?.label
                    ? columnFilter.macroregion.options
                    : (columnFilter.macroregion.options || []).map((o) => ({
                          label: o,
                          value: o,
                      })),
            value:
                !!field && field !== 'macroregion'
                    ? columnFilter.macroregion.value
                    : smartFilter?.macroregion,
        },
        region: {
            ...columnFilter.region,
            options:
                columnFilter.region.options && columnFilter.region.options[0]?.label
                    ? columnFilter.region.options
                    : (columnFilter.region.options || []).map((o) => ({
                          label: o,
                          value: o,
                      })),
            value: !!field && field !== 'region' ? columnFilter.region.value : smartFilter?.region,
        },
        zone_desc: {
            ...columnFilter.zone_desc,
            options:
                columnFilter.zone_desc.options && columnFilter.zone_desc.options[0]?.label
                    ? columnFilter.zone_desc.options
                    : (columnFilter.zone_desc.options || []).map((o) => ({
                          label: o,
                          value: o,
                      })),
            value:
                !!field && field !== 'zone_desc'
                    ? columnFilter.zone_desc.value
                    : smartFilter?.zoneDesc,
        },
        host: {
            ...columnFilter.host,
            options:
                columnFilter.host.options && columnFilter.host.options[0]?.label
                    ? columnFilter.host.options
                    : (columnFilter.host.options || []).map((o) => ({
                          label: o,
                          value: o,
                      })),
            value: !!field && field !== 'host' ? columnFilter.host.value : smartFilter?.host,
        },
        city: {
            ...columnFilter.city,
            options:
                columnFilter.city.options && columnFilter.city.options[0]?.label
                    ? columnFilter.city.options
                    : (columnFilter.city.options || []).map((o) => ({
                          label: o,
                          value: o,
                      })),
            value: !!field && field !== 'city' ? columnFilter.city.value : smartFilter?.city,
        },
        store_location: {
            ...columnFilter.store_location,
            options:
                columnFilter.store_location.options && columnFilter.store_location.options[0]?.label
                    ? columnFilter.store_location.options
                    : (columnFilter.store_location.options || []).map((o) => ({
                          label: o,
                          value: o,
                      })),
            value:
                !!field && field !== 'store_location'
                    ? columnFilter.store_location.value
                    : smartFilter?.storeLocation,
        },
        store_host_name: {
            ...columnFilter.store_host_name,
            options:
                columnFilter.store_host_name.options &&
                columnFilter.store_host_name.options[0]?.label
                    ? columnFilter.store_host_name.options
                    : (columnFilter.store_host_name.options || []).map((o) => ({
                          label: o,
                          value: o,
                      })),
            value:
                !!field && field !== 'store_host_name'
                    ? columnFilter.store_host_name.value
                    : smartFilter?.storeHostName,
        },
        business_model: {
            ...columnFilter.business_model,
            options:
                columnFilter.business_model.options && columnFilter.business_model.options[0]?.label
                    ? columnFilter.business_model.options
                    : (columnFilter.business_model.options || []).map((o) => ({
                          label: o,
                          value: o,
                      })),
            value:
                !!field && field !== 'business_model'
                    ? columnFilter.business_model.value
                    : smartFilter?.businessModel,
        },
        segment: {
            ...columnFilter.segment,
            options:
                columnFilter.segment.options && columnFilter.segment.options[0]?.label
                    ? columnFilter.segment.options
                    : (columnFilter.segment.options || []).map((o) => ({
                          label: o,
                          value: o,
                      })),
            value:
                !!field && field !== 'segment' ? columnFilter.segment.value : smartFilter?.segment,
        },
    }
}

export const getExternalFiltersValue = (
    externalFilter: Record<string, any>
): Record<any, LazyParamsFilters> => {
    return {
        banner_desc: {
            value: externalFilter?.banner,
        },
        country: { value: externalFilter?.country },
        macroregion: {
            value: externalFilter?.macroregion,
        },
        region: { value: externalFilter?.region },
        zone_desc: {
            value: externalFilter?.zone,
        },
        host: { value: externalFilter?.host },
        city: { value: externalFilter?.city },
        store_location: {
            value: externalFilter?.storeLocation,
        },
        store_host_name: {
            value: externalFilter?.storeHost,
        },
        business_model: {
            value: externalFilter?.businessModel,
        },
        segment: { value: externalFilter?.segment },
    }
}

export const setInitialFilters = ({
    filtersOptionsMap,
    smartFilter,
    externalFilters,
    field,
}: {
    filtersOptionsMap: Record<string, any>
    smartFilter: Record<string, string[]>
    externalFilters?: Record<string, any>
    field?: string
}) => {
    const filters = getInitialFilters(filtersOptionsMap)
    if (!!Object.keys(smartFilter || {}).length) {
        return setSmartFiltersOptions(
            getInitialFilters(filtersOptionsMap, getSmartFiltersValue(smartFilter), field)
        )
    }
    if (externalFilters) {
        return getInitialFilters(filtersOptionsMap, getExternalFiltersValue(externalFilters), field)
    }
    return filters
}
